export const IDENTIFICADOR_PERFIL_DIRETOR = 6;

